import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#0C0C0C] text-white pt-12">
      <div className="container mx-auto px-6 lg:px-20 flex flex-col lg:flex-row justify-between items-start pb-4">
        {/* Logo Section */}
        <div className="flex flex-col items-center lg:items-start w-full lg:w-2/4  mb-6 lg:mb-0">
          <img
            src="/assets/images/logo.png"
            alt="Currency Exchange Logo"
            className="w-[30%]"
          />
        </div>
        {/* Tools & Resources */}
        <div className="w-full lg:w-1/4 mb-6 lg:mb-0">
          <h2 className="text-lg font-bold mb-4">Tools & Resources</h2>
          <ul className="space-y-2">
            <li>
              <a href="#" className="hover:text-gray-400">
                Blog
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Currency Converter
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Currency Charts
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Historical Rates
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Currency Encyclopedia
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Rate Alerts
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Newsletters
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                IBAN Calculator
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Glossary
              </a>
            </li>
          </ul>
        </div>
        {/* Company Info */}
        <div className="w-full lg:w-1/4 mb-6 lg:mb-0">
          <h2 className="text-lg font-bold mb-4">Company Info</h2>
          <ul className="space-y-2">
            <li>
              <a href="#" className="hover:text-gray-400">
                About Us
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Partnerships
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Careers
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Help Center
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Dedicated Support
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Site Map
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Legal
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-400">
                Money Transfer Info
              </a>
            </li>
          </ul>
          <div className="flex justify-center lg:justify-start space-x-4 text-xl pt-6">
            <a href="#" className="hover:text-gray-400">
              <FaFacebookF />
            </a>
            <a href="#" className="hover:text-gray-400">
              <FaTwitter />
            </a>
            <a href="#" className="hover:text-gray-400">
              <FaLinkedinIn />
            </a>
            <a href="#" className="hover:text-gray-400">
              <FaInstagram />
            </a>
          </div>
        </div>
        {/* Social Media */}
      </div>
      {/* Copyright */}
      <div className="text-center  border-t border-gray-700 py-4">
        <p className="text-sm">© 2025 Currency Exchange.</p>
      </div>
    </footer>
  );
};

export default Footer;
